import attachmentSchema from './attachment.schema';
import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    attachments: {
      title: 'Załączniki procedury',
      type: 'array',
      items: attachmentSchema,
      warnings: {
        minItems: 1,
        maxItems: 5
      }
    }
  },
  allOf: [validationMessages]
};
